import { useQuery } from '@tanstack/react-query';

import { listExpiringCppRateCards } from '~/services/LuxLoyaltyService';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

/** Lists ACTIVE CPP rate cards expiring within `withinDays` (default 30). */
export function useExpiringCppRateCards(withinDays = 30) {
  return useQuery({
    queryKey: costPerPointQueryKeys.expiring(withinDays),
    queryFn: async ({ signal }) => {
      return await listExpiringCppRateCards(withinDays, { signal });
    },
    retry: false,
  });
}
